import React, { useEffect, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import ErrorMessage from '../ErrorMessage';
import Input, { InputProps } from '../Input';
import TopFieldContent from '../TopFieldContent';
import useTranslation from '../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './InputFieldWithPrefix.module.scss';

interface InputFieldProps extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	prefix: string;
}

const InputFieldWithPrefix = ({
	name,
	label,
	isRequired,
	className,
	placeholder,
	prefix,
	onChange,
	...inputProps
}: InputFieldProps) => {
	const { t } = useTranslation();
	const { fieldName } = useFormName({ name });
	const [value, setValue] = useState();

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const handleOnInputChange = (val: any) => {
		field.onChange(`${prefix}${val.target.value}`);
	};

	useEffect(() => {
		setValue(field.value.replace(prefix, ''));
	}, [field]);

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<div className={styles.wrapper}>
				<div className={styles.prefix}>{prefix}</div>
				<Input
					className={styles.input}
					hasError={Boolean(error?.message)}
					{...inputProps}
					{...field}
					value={value}
					onChange={handleOnInputChange}
					placeholder={t(placeholder)}
				/>
			</div>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default InputFieldWithPrefix;
